import { gql } from '@apollo/client/core';

export const UseEventSearchFragment = gql`
  fragment UseEventSearchFragment on vEvents {
    id
    active
    card
    bits
    status
    time
    serverTime
    type
    duration
    hasVideo
    inCloud
    onGateway
    eventStart
    eventEnd
    sensorID
    sensor {
      id
      name
      type
    }
    personID
    person {
      id
      avatar_sm
      firstName
      lastName
    }
    doorID
    door {
      id
      name
    }
    videoSourceID
    videoSource {
      id
      name
    }
    mediaProfileID
    deviceID
    device {
      id
      name
      kind
    }
    zoneID
    zone {
      id
      name
    }
    partitionID
    partition {
      id
      name
    }
    gatewayID
    toType {
      priority
    }
    placeID
    place {
      id
      name
      path
      hierarchy {
        name
      }
      gateway {
        id
        name
        type
      }
    }
    profile
    snapshot {
      id
      signedUrl
      aspectRatio
    }
  }
`

/** Leaner fragment for Live Scroller initial load / history (no Search-only fields). */
export const LiveScrollerEventFragment = gql`
  fragment LiveScrollerEventFragment on vEvents {
    id
    active
    card
    bits
    status
    time
    serverTime
    type
    profile
    duration
    hasVideo
    sensorID
    sensor {
      id
      name
      type
    }
    personID
    person {
      id
      avatar_sm
      firstName
      lastName
    }
    doorID
    door {
      id
      name
    }
    videoSourceID
    videoSource {
      id
      name
    }
    mediaProfileID
    deviceID
    device {
      id
      name
      kind
    }
    zoneID
    zone {
      id
      name
    }
    partitionID
    partition {
      id
      name
    }
    gatewayID
    toType {
      priority
    }
    placeID
    place {
      id
      name
      path
      hierarchy {
        name
      }
      gateway {
        id
        name
        type
      }
    }
    snapshot {
      id
      signedUrl
      aspectRatio
    }
  }
`;

export const GQL_GET_AI_TOOL_RESULT_EVENTS_BY_IDS = gql`
  query GQL_GET_AI_TOOL_RESULT_EVENTS_BY_IDS($ids: [bigint!]!) {
    vEvents(where: { id: { _in: $ids } }) {
      ...UseEventSearchFragment
    }
  }
  ${UseEventSearchFragment}
`;

export const GQL_SEARCH_V_EVENTS = gql`
  query GQL_SEARCH_V_EVENTS(
    $where: vEvents_bool_exp!,
    $limit: Int!,
    $order_by: [vEvents_order_by!]!
  ) {
    vEvents(
      where: $where,
      limit: $limit,
      order_by: $order_by,
    ) {
      ...UseEventSearchFragment
    }
  }
  ${UseEventSearchFragment}
`;

export const GQL_LIVE_SCROLLER_V_EVENTS = gql`
  query GQL_LIVE_SCROLLER_V_EVENTS(
    $where: vEvents_bool_exp!,
    $limit: Int!,
    $order_by: [vEvents_order_by!]!
  ) {
    vEvents(where: $where, limit: $limit, order_by: $order_by) {
      ...LiveScrollerEventFragment
    }
  }
  ${LiveScrollerEventFragment}
`;

export const GQL_SUBSCRIBE_V_EVENTS = gql`
  subscription GQL_SUBSCRIBE_V_EVENTS(
    $where: vEvents_bool_exp!,
    $limit: Int!,
    $order_by: [vEvents_order_by!]!
  ) {
    vEvents(
      where: $where,
      limit: $limit,
      order_by: $order_by,
    ) {
      ...UseEventSearchFragment
    }
  }
  ${UseEventSearchFragment}
`;

export const doorsPlacesAndCameras = gql`
  query doorsPlacesAndCameras($path: String!) {
    places(where: { path: { _like: $path } }) {
      id
      name
    }
    people(where: { place: { path: { _like: $path } } }) {
      id
      lastName
      firstName
    }
    doors(where: { place: { path: { _like: $path } } }) {
      id
      name
    }
    videoSources(where: { place: { path: { _like: $path } } }) {
      id
      name
    }
  }
`;
